export interface MenuItem {
  id: number;
  name: string;
  price: number;
  description: string;
  image: string;
  likes: number;
  inCart: number;
  dietaryTags?: string[]; // e.g., ['vegetarian', 'vegan', 'gluten-free']
}

export interface MenuCategory {
  id: string;
  name: string;
  iconName: string;
  selected: boolean;
}

export const menuCategories: MenuCategory[] = [
  { id: 'popular', name: 'Popular', iconName: 'Restaurant', selected: true },
  { id: 'starters', name: 'Starters', iconName: 'Restaurant', selected: false },
  { id: 'tacos', name: 'Tacos', iconName: 'Restaurant', selected: false },
  { id: 'burritos', name: 'Burritos', iconName: 'Restaurant', selected: false },
  { id: 'quesadillas', name: 'Quesadillas', iconName: 'Restaurant', selected: false },
  { id: 'bowls', name: 'Bowls', iconName: 'Restaurant', selected: false },
  { id: 'specialties', name: 'Specialties', iconName: 'Restaurant', selected: false },
  { id: 'sides', name: 'Sides', iconName: 'Restaurant', selected: false },
  { id: 'kids', name: "Kids' Menu", iconName: 'ChildCare', selected: false },
  { id: 'specialty-drinks', name: 'Specialty Drinks', iconName: 'LocalBar', selected: false },
  { id: 'drinks', name: 'Drinks', iconName: 'LocalBar', selected: false },
  { id: 'dessert', name: 'Dessert', iconName: 'Cake', selected: false },
  { id: 'hot-sauces', name: "Talkin' Tacos Hot Sauces 🔥", iconName: 'Whatshot', selected: false },
  { id: 'catering', name: 'Catering', iconName: 'Event', selected: false }
];

// Bowls
export const bowlItems: MenuItem[] = [
  {
    id: 1,
    name: 'Birria Rice Bowl',
    price: 15.99,
    description: 'Crispy Flour Tortilla Bowl, Mexican Rice, Refried Beans, Lettuce, Pico de Gallo, Avocado Salsa, Cotija Cheese, and Cilantro.',
    image: 'https://photos.tryotter.com/cdn-cgi/image/fit=crop,width=256,quality=80/menu-photos/aea9d2f6-a351-41c0-bec1-bffa89698763.jpeg',
    likes: 3,
    inCart: 0
  },
  {
    id: 2,
    name: 'Chicken Rice Bowl',
    price: 15.99,
    description: 'Crispy Flour Tortilla Bowl, Mexican Rice, Refried Beans, Lettuce, Pico de Gallo, Avocado Salsa, Cotija Cheese, and Cilantro.',
    image: 'https://photos.tryotter.com/cdn-cgi/image/fit=crop,width=256,quality=80/menu-photos/fb819479-e406-4d84-9170-d522ea0a5f35.jpeg',
    likes: 7,
    inCart: 0
  },
  {
    id: 3,
    name: 'Steak Rice Bowl',
    price: 15.99,
    description: 'Crispy Flour Tortilla Bowl, Mexican Rice, Refried Beans, Lettuce, Pico de Gallo, Avocado Salsa, Cotija Cheese, and Cilantro.',
    image: 'https://photos.tryotter.com/cdn-cgi/image/fit=crop,width=256,quality=80/menu-photos/c4a41bdf-9e52-40fa-9e83-61e662cbbfc5.jpeg',
    likes: 7,
    inCart: 0
  },
  {
    id: 4,
    name: 'Bean Rice Bowl',
    price: 15.99,
    description: 'Fresh Mixed Greens, Quinoa, Edamame, Corn, Cucumber, Purple Cabbage, Cherry Tomatoes, and Choice of Protein with Light Vinaigrette.',
    image: 'https://photos.tryotter.com/cdn-cgi/image/fit=crop,width=256,quality=80/menu-photos/3b74957e-91f6-4ad7-bb1b-7f715cf21701.jpeg',
    likes: 0,
    inCart: 0,
    dietaryTags: ['vegetarian']
  },
  {
    id: 5,
    name: 'Taco Salad',
    price: 15.99,
    description: 'Crispy Flour Tortilla Bowl, Fresh Lettuce, Your Choice of Protein, Homemade Guacamole, Pico de Gallo, and Crumbled Cotija Cheese.',
    image: 'https://photos.tryotter.com/cdn-cgi/image/fit=crop,width=828,quality=80/menu-photos/4dd61071-a804-4057-a225-2015145bcda2.jpeg',
    likes: 12,
    inCart: 0
  }
];

// Burritos
export const burritoItems: MenuItem[] = [
  {
    id: 6,
    name: 'Birria Burrito',
    price: 15.99,
    description: 'Flour Tortilla, Mexican Rice, Refried Beans, Chihuahua Cheese, Lettuce, Pico de Gallo, Takis, Avocado Salsa, and Sour Cream. Served with Chips.',
    image: 'https://photos.tryotter.com/cdn-cgi/image/fit=crop,width=256,quality=80/menu-photos/838874a0-af54-4eaa-82a1-bdea7fa6cc99.jpeg',
    likes: 8,
    inCart: 0
  },
  {
    id: 7,
    name: 'Steak Burrito',
    price: 15.99,
    description: 'Flour Tortilla, Mexican Rice, Refried Beans, Chihuahua Cheese, Lettuce, Pico de Gallo, Takis, Avocado Salsa, and Sour Cream. Served with Chips.',
    image: 'https://photos.tryotter.com/cdn-cgi/image/fit=crop,width=256,quality=80/menu-photos/24e90c12-a03a-4f23-a570-a73ed1fa984a.jpeg',
    likes: 15,
    inCart: 0
  },
  {
    id: 8,
    name: 'Shrimp Burrito',
    price: 15.99,
    description: 'Flour Tortilla, Mexican Rice, Refried Beans, Chihuahua Cheese, Lettuce, Pico de Gallo, Takis, Avocado Salsa, and Sour Cream. Served with Chips.',
    image: 'https://photos.tryotter.com/cdn-cgi/image/fit=crop,width=256,quality=80/menu-photos/50fe3fb3-de52-441c-b014-4f5ed3b75b06.jpeg',
    likes: 6,
    inCart: 0
  },
  {
    id: 22,
    name: 'Mahi Mahi Burrito',
    price: 12.99,
    description: 'Flour Tortilla, Mexican Rice, Refried Beans, Chihuahua Cheese, Lettuce, Pico de Gallo, Takis, Avocado Salsa, and Sour Cream. Served with Chips.',
    image: 'https://photos.tryotter.com/cdn-cgi/image/fit=crop,width=256,quality=80/menu-photos/36f3d190-ed19-4c2a-923d-29b2ff9d4d3d.jpeg',
    likes: 0,
    inCart: 0
  }
];

// Tacos
export const tacoItems: MenuItem[] = [
  {
    id: 9,
    name: 'Birria Tacos',
    price: 15.99,
    description: 'Three Birria Tacos: Corn Tortilla, Chihuahua Cheese, Beef Birria, Onions, Cilantro, and Consommé.',
    image: 'https://photos.tryotter.com/cdn-cgi/image/fit=crop,width=384,quality=80/menu-photos/665d7ee2-5efb-473f-a2bc-b87be16f9913.jpeg',
    likes: 22,
    inCart: 0,
    dietaryTags: ['gluten-free']
  },
  {
    id: 10,
    name: 'Bang Bang Shrimp Tacos',
    price: 15.99,
    description: 'Three Bang Bang Shrimp Tacos: Corn Tortilla, Lettuce, Fried Shrimp, Spicy Mayo, Pickled Onions, and Cilantro.',
    image: 'https://photos.tryotter.com/cdn-cgi/image/fit=crop,width=384,quality=80/menu-photos/7e5d1213-ffe5-4910-bd66-044bbbf66884.jpeg',
    likes: 18,
    inCart: 0,
    dietaryTags: ['gluten-free']
  },
  {
    id: 11,
    name: 'Southwest Chicken Tacos',
    price: 15.99,
    description: 'Three Southwest Chicken Tacos: Corn Tortilla, Grilled Chicken, Black Bean Salsa, Spicy Mayo, Fried Onions, Cotija Cheese, and Cilantro.',
    image: 'https://photos.tryotter.com/cdn-cgi/image/fit=crop,width=384,quality=80/menu-photos/8b8a9349-ed9a-464d-8f4d-322ed23730e8.jpeg',
    likes: 11,
    inCart: 0,
    dietaryTags: ['gluten-free']
  },
  {
    id: 19,
    name: 'Carne Asada Tacos',
    price: 14.99,
    description: 'Three Carne Asada Tacos: Corn Tortilla, Marinated Steak, Salsa Verde, and Cilantro.',
    image: 'https://photos.tryotter.com/cdn-cgi/image/fit=crop,width=256,quality=80/menu-photos/e7f860b0-ebb5-48f4-95d5-ce2c5ba236b7.jpeg',
    likes: 0,
    inCart: 0,
    dietaryTags: ['gluten-free']
  },
  {
    id: 20,
    name: 'Caribbean Carne Tacos',
    price: 14.99,
    description: 'Three Caribbeans Carne Tacos: Corn Tortilla, Marinated Steak, Sweet Plantains, Avocado Salsa, Cotija Cheese, and Cilantro.',
    image: 'https://photos.tryotter.com/cdn-cgi/image/fit=crop,width=256,quality=80/menu-photos/447a846a-9619-4c9f-871b-74e1c7d0aca0.jpeg',
    likes: 0,
    inCart: 0,
    dietaryTags: ['gluten-free']
  }
];

// Starters
export const starterItems: MenuItem[] = [
  {
    id: 12,
    name: 'App Trio',
    price: 21.99,
    description: 'An assortment of our most popular starters: Pico de Gallo, Guacamole, and Jalapeño Taki Queso. Served with Chips.',
    image: 'https://photos.tryotter.com/cdn-cgi/image/fit=crop,width=384,quality=80/menu-photos/1dd2b886-5f0d-48b5-89fd-7162cfefd52b.jpeg/CAESJRoOEgwKAwj8JRIDCPwlGAEaERoPCICA8QQSAgECGJADIJADKFU.jpeg',
    likes: 25,
    inCart: 0
  },
  {
    id: 13,
    name: 'Guacamole and Chips',
    price: 8.99,
    description: 'Creamy Avocado Mixed with Fresh Lime, Cilantro, and a Touch of Seasoning For a Perfect Balance of Flavors, Served with Chips.',
    image: 'https://photos.tryotter.com/cdn-cgi/image/fit=crop,width=256,quality=80/menu-photos/af63a9a1-13ab-493d-967b-3938c429dc09.jpeg',
    likes: 19,
    inCart: 0,
    dietaryTags: ['vegetarian']
  },
  {
    id: 14,
    name: 'Pico De Gallo and Chips',
    price: 7.99,
    description: 'A Fresh, Zesty Mix of Diced Tomatoes, Onions, Cilantro, and Lime, With a Hint of Spice, Served with Chips.',
    image: 'https://photos.tryotter.com/cdn-cgi/image/fit=crop,width=256,quality=80/menu-photos/969ede5f-9f8b-4e72-b2c9-a22c6971d321.jpeg',
    likes: 14,
    inCart: 0,
    dietaryTags: ['vegetarian']
  },
  {
    id: 15,
    name: 'Jalapeño Taki Queso and Chips',
    price: 6.99,
    description: 'A Rich, Creamy Melted Cheese Dip, Perfectly Seasoned For a Smooth, Savory Treat, Served with Chips.',
    image: 'https://photos.tryotter.com/cdn-cgi/image/fit=crop,width=640,quality=80/menu-photos/688e3ed2-5f99-4904-a658-15462794b67f.jpeg',
    likes: 16,
    inCart: 0,
    dietaryTags: ['vegetarian']
  }
];

// Quesadillas
export const quesadillaItems: MenuItem[] = [
  {
    id: 16,
    name: 'Quesabirria',
    price: 15.99,
    description: 'Flour Tortilla, Chihuahua Cheese, Onions, Cilantro, Consommé, and Chips.',
    image: 'https://photos.tryotter.com/cdn-cgi/image/fit=crop,width=256,quality=80/menu-photos/6b8dda21-4848-46d8-b90c-2040bbedbd37.jpeg/CAESMRoaEhgKAwj8JRIDCPwlGAEiCg09Ctc-Fdej8D4aERoPCICA8QQSAgECGJADIJADKFU.jpeg',
    likes: 28,
    inCart: 0
  },
  {
    id: 17,
    name: 'Steak Quesabirria',
    price: 15.99,
    description: 'Flour Tortilla, Chihuahua Cheese, Onions, Cilantro, Consommé, and Chips.',
    image: 'https://photos.tryotter.com/cdn-cgi/image/fit=crop,width=256,quality=80/menu-photos/0df1ac21-7105-46c3-9104-aa3cdecdd915.jpeg',
    likes: 21,
    inCart: 0
  },
  {
    id: 18,
    name: 'Pabellon Quesabirria',
    price: 15.99,
    description: 'Flour Tortilla, Avocado Salsa, Chihuahua Cheese, Birria, Sweet Plantain, Black Beans, Onions, Cilantro, Chips.',
    image: 'https://photos.tryotter.com/cdn-cgi/image/fit=crop,width=256,quality=80/menu-photos/73473a4a-71f8-4252-a3b4-f0cd368eaa1e.jpeg',
    likes: 13,
    inCart: 0
  },
  {
    id: 21,
    name: 'Chicken Quesabirria',
    price: 15.99,
    description: 'Flour Tortilla, Chihuahua Cheese, Onions, Cilantro, Consommé, and Chips.',
    image: 'https://photos.tryotter.com/cdn-cgi/image/fit=crop,width=256,quality=80/menu-photos/b10eff0f-9ba0-4d4d-998d-58e9af99cbf0.jpeg',
    likes: 0,
    inCart: 0
  }
];

// All menu items combined
export const allMenuItems: MenuItem[] = [
  ...bowlItems,
  ...burritoItems,
  ...tacoItems,
  ...starterItems,
  ...quesadillaItems
];
